import { Component, OnDestroy } from '@angular/core'
import { MbCheckoutConfirmationBaseComponent } from '../mb-checkout-confirmation-base.component'
import { Router } from '@angular/router'
import { MbOrderService } from '../../../services/mb-order.service'
import { MbCheckoutRegions } from '../../../../models'
import { OrderHistoryService } from '@spartacus/order/core'

@Component({
  selector: 'mb-checkout-confirmation-au',
  templateUrl: './mb-checkout-confirmation-au.component.html',
  styleUrls: ['../mb-checkout-confirmation-base.component.scss']
})
export class MbCheckoutConfirmationAuComponent extends MbCheckoutConfirmationBaseComponent implements OnDestroy {

  checkoutRegion = MbCheckoutRegions.AU

  constructor (protected orderService: OrderHistoryService,
               protected mbCheckoutService: MbOrderService,
               protected router: Router) {
    super(orderService, router)
  }

  ngOnDestroy () {
    this.mbCheckoutService.stopPlaceOrderTrigger()
  }
}
